import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import moment from 'moment';
import * as _ from 'lodash';
import { LOGOUT_SUCCESS, RESET_TO_INITIAL_STATE } from './auth';
import { UNLINK_GROUP_POST_SUCCESS, DELETE_GROUP_POST_SUCCESS } from 'redux/modules/groupPosts';
import { SUBMIT_POST_SUCCESS as GROUP_POST_SUBMIT_POST_SUCCESS } from 'redux/modules/groupPostCompose';
import { SUBMIT_POST_SUCCESS } from 'redux/modules/composeboxForm';
import { REMOVE_CATEGORY_SUCCESS, UPDATE_QUEUE_SUCCESS, REMOVE_QUEUE_ITEM_SUCCESS } from 'redux/modules/queues';
import { DELETE_ACCOUNT_LINK_SUCCESS, CREATE_POST_TIME_SUCCESS, DELETE_POST_TIME_SUCCESS, CREATE_NEEDED_QUEUES_SUCCESS } from 'redux/modules/contentLibraryQueues';
import { SUBMIT_ACCOUNT_LINK_SUCCESS, ENQUEUE_POST_SUCCESS } from 'redux/modules/contentLibrary';
var ns = 'likeablelocal/schedule';
var WIPE_CACHE = "".concat(ns, "/WIPE_CACHE");
var DELETE_POST = "".concat(ns, "/DELETE_POST");
export var DELETE_POST_SUCCESS = "".concat(ns, "/DELETE_POST_SUCCESS");
var DELETE_POST_FAIL = "".concat(ns, "/DELETE_POST_FAIL");
var LOAD_POSTS = "".concat(ns, "/LOAD_POSTS");
var LOAD_POSTS_SUCCESS = "".concat(ns, "/LOAD_POSTS_SUCCESS");
var LOAD_POSTS_FAIL = "".concat(ns, "/LOAD_POSTS_FAIL");
var SELECT_FILTERS = "".concat(ns, "/SELECT_FILTERS");
var CLICK_POST_POPOVER_ACTION_BTN = 'likeablelocal/schedule/CLICK_POST_POPOVER_ACTION_BTN';
var initialState = {
  clickedPostPopoverActionButton: false,
  loadedUrls: [],
  loadingPosts: false,
  posts: {},
  calendarFilters: {}
};
export default function schedule() {
  var _state$posts;

  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case RESET_TO_INITIAL_STATE:
    case LOGOUT_SUCCESS:
      return initialState;

    case CLICK_POST_POPOVER_ACTION_BTN:
      return _objectSpread(_objectSpread({}, state), {}, {
        clickedPostPopoverActionButton: true
      });

    case SUBMIT_POST_SUCCESS:
    case GROUP_POST_SUBMIT_POST_SUCCESS:
    case UNLINK_GROUP_POST_SUCCESS:
    case DELETE_GROUP_POST_SUCCESS:
    case SUBMIT_ACCOUNT_LINK_SUCCESS:
    case ENQUEUE_POST_SUCCESS:
    case DELETE_ACCOUNT_LINK_SUCCESS:
    case CREATE_POST_TIME_SUCCESS:
    case DELETE_POST_TIME_SUCCESS:
    case CREATE_NEEDED_QUEUES_SUCCESS:
    case REMOVE_CATEGORY_SUCCESS:
    case UPDATE_QUEUE_SUCCESS:
    case REMOVE_QUEUE_ITEM_SUCCESS:
    case WIPE_CACHE:
      return _objectSpread(_objectSpread({}, state), {}, {
        loadedUrls: state.loadedUrls.filter(function (url) {
          return !_.includes(url, action.orgId);
        }),
        posts: _objectSpread(_objectSpread({}, state.posts), {}, _defineProperty({}, action.orgId, []))
      });

    case SELECT_FILTERS:
      return _objectSpread(_objectSpread({}, state), {}, {
        calendarFilters: _defineProperty({}, action.orgId, _toConsumableArray(action.filters))
      });

    case LOAD_POSTS:
      return _objectSpread(_objectSpread({}, state), {}, {
        loadingPosts: true
      });

    case LOAD_POSTS_SUCCESS:
      var posts = action.result.data.map(function (post) {
        var timezone = action.orgTimezone.details;
        var tzPublishAt = moment.utc(post.publishAt).add(timezone.utc_offset.hours, 'hours').add(timezone.utc_offset.minutes, 'minutes');
        var platforms = post.QueueId && post.Queue && post.Queue.type ? [post.Queue.type.split(' ').join('').toLowerCase()] : post.type === 'AD' ? ['facebook'] : post === null || post === void 0 ? void 0 : post.SocialAccountPosts.map(function (sa) {
          var _sa$SocialAccount;

          if (sa !== null && sa !== void 0 && (_sa$SocialAccount = sa.SocialAccount) !== null && _sa$SocialAccount !== void 0 && _sa$SocialAccount.platform && sa.SocialAccount.platform.split(' ')[0].toLowerCase() === 'linkedin') {
            var pieces = sa.SocialAccount.platform.split(' ');
            return "".concat(pieces[0].toLowerCase()).concat(pieces[1].toLowerCase());
          } else {
            var _sa$SocialAccount2;

            return sa === null || sa === void 0 ? void 0 : (_sa$SocialAccount2 = sa.SocialAccount) === null || _sa$SocialAccount2 === void 0 ? void 0 : _sa$SocialAccount2.platform.split(' ')[0].toLowerCase();
          }
        });
        var imageObjs = post.S3Files && post.S3Files.length ? post.S3Files.map(function (file) {
          var placement = 0;

          if (file && file.PostS3File) {
            placement = file.PostS3File.placement;
          }

          return {
            url: file.fullyQualifiedUrl,
            placement: placement
          };
        }) : [];

        function compareByPlacement(a, b) {
          if (a.placement > b.placement) {
            return 1;
          } else if (a.placement < b.placement) {
            return -1;
          } else {
            return 0;
          }
        }

        if (post.type != 'AD' && imageObjs && imageObjs.length) {
          imageObjs.sort(compareByPlacement);
        }

        var images = imageObjs.map(function (image) {
          return image.url;
        });
        var postType = 'textPost';

        if (post.linkUrl) {
          postType = 'linkPost';
        } else if (post.videoUrl) {
          postType = 'videoPost';
        } else if (images.length) {
          postType = 'imagePost';
        }

        var messages = {
          global: post.message
        };

        if (post.SocialAccountPosts && !!post.SocialAccountPosts.length && !_.isEmpty(post.SocialAccountPosts[0])) {
          post.SocialAccountPosts.forEach(function (sap) {
            var _sap$SocialAccount;

            if (messages[sap === null || sap === void 0 ? void 0 : (_sap$SocialAccount = sap.SocialAccount) === null || _sap$SocialAccount === void 0 ? void 0 : _sap$SocialAccount.platform]) {
              messages[sap.SocialAccount.platform.split(' ')[0].toLowerCase()] = sap.message;
            }
          });
        }

        return _objectSpread(_objectSpread({}, post), {}, {
          imageUrl: post.S3Files && post.S3Files.length ? post.S3Files[0].fullyQualifiedUrl : null,
          platforms: platforms,
          images: images,
          messages: messages,
          postType: postType
        });
      });
      var existingPosts = ((_state$posts = state.posts) === null || _state$posts === void 0 ? void 0 : _state$posts[action.orgId]) || [];
      return _objectSpread(_objectSpread({}, state), {}, {
        loadingPosts: false,
        loadedUrls: _.union(state.loadedUrls, [action.reqUrl]),
        posts: _objectSpread(_objectSpread({}, state.posts), {}, _defineProperty({}, action.orgId, _.unionWith(existingPosts, posts, function (aVal, bVal) {
          return aVal.id === bVal.id;
        })))
      });

    case LOAD_POSTS_FAIL:
      return _objectSpread(_objectSpread({}, state), {}, {
        loadingPosts: false
      });

    case DELETE_POST:
      return _objectSpread(_objectSpread({}, state), {}, {
        deletingPost: true
      });

    case DELETE_POST_SUCCESS:
      if (action.post.QueueId) {
        return _objectSpread(_objectSpread({}, state), {}, {
          deletingPost: false
        });
      } else {
        return _objectSpread(_objectSpread({}, state), {}, {
          deletingPost: false,
          posts: _objectSpread(_objectSpread({}, state.posts), {}, _defineProperty({}, action.orgId, state.posts[action.orgId].filter(function (p) {
            return parseInt(p.id) !== parseInt(action.post.id);
          })))
        });
      }

    case DELETE_POST_FAIL:
      return _objectSpread(_objectSpread({}, state), {}, {
        deletingPost: false
      });

    default:
      return state;
  }
}
export function clickPostPopoverActionButton() {
  return {
    type: 'CLICK_POST_POPOVER_ACTION_BTN'
  };
}
export var associateIdeaToTag = function associateIdeaToTag(ideaId, tag) {
  var actionType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : client.ACTION_TYPE.ADD;
  return function (dispatch) {
    dispatch({
      type: LINK_IDEA_TO_TAG,
      ideaId: ideaId,
      tag: tag,
      actionType: actionType
    });
    return client.ideas.associateToTag(ideaId, tag.id, actionType).then(function (_ref) {
      var result = _ref.data.result;
      dispatch({
        type: LINK_IDEA_TO_TAG_SUCCESS,
        ideaId: ideaId,
        tags: result
      });
    })["catch"](function (error) {
      console.error(error);
      dispatch({
        type: LINK_IDEA_TO_TAG_FAIL,
        error: error
      });
    });
  };
};
export function getOrgPosts(orgId, orgTimezone, startDateTime, endDateTime, forceReload) {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState, client) {
      var _getState, schedule, start, end, url, result;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _getState = getState(), schedule = _getState.schedule;
              start = moment.utc(startDateTime).startOf('day').toDate().getTime();
              end = moment.utc(endDateTime).endOf('day').toDate().getTime();
              url = "/org/".concat(orgId, "/posts?from=").concat(start, "&to=").concat(end);

              if (!(schedule.loadedUrls.includes(url) && !forceReload)) {
                _context.next = 8;
                break;
              }

              return _context.abrupt("return", false);

            case 8:
              dispatch({
                type: LOAD_POSTS
              });
              _context.prev = 9;
              _context.next = 12;
              return client.get(url);

            case 12:
              result = _context.sent;
              dispatch({
                type: LOAD_POSTS_SUCCESS,
                result: result,
                orgId: orgId,
                orgTimezone: orgTimezone,
                reqUrl: url
              });
              _context.next = 20;
              break;

            case 16:
              _context.prev = 16;
              _context.t0 = _context["catch"](9);
              console.error(_context.t0);
              dispatch({
                type: LOAD_POSTS_FAIL,
                error: _context.t0
              });

            case 20:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[9, 16]]);
    }));

    return function (_x, _x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }();
}
export function deletePost(post) {
  var promise;

  if (post.QueueId) {
    var url = "/org/".concat(post.OrganizationId, "/queue/").concat(post.QueueId);
    var body = {
      postIds: post.id,
      action: 'remove'
    };

    promise = function promise(client) {
      return client.post(url, {
        data: body
      });
    };
  } else {
    promise = function promise(client) {
      return client.del("/organization/".concat(post.OrganizationId, "/post/").concat(post.id));
    };
  }

  return {
    types: [DELETE_POST, DELETE_POST_SUCCESS, DELETE_POST_FAIL],
    promise: promise,
    orgId: post.OrganizationId,
    post: post
  };
}
export function wipeCache(orgId) {
  return {
    type: WIPE_CACHE,
    orgId: orgId
  };
}
export function getSelectedFilters(orgId, filters) {
  return /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(dispatch) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              try {
                dispatch({
                  type: SELECT_FILTERS,
                  orgId: orgId,
                  filters: filters
                });
              } catch (err) {
                console.error(err);
              }

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x4) {
      return _ref3.apply(this, arguments);
    };
  }();
}